import { SortMenuType } from 'components/utils/Sort';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { InsightType } from '../apis/PythonInsightsAPI';
import useUserData from 'hooks/useUserData';
import { useConfigQuery } from '@buildwise/libs/configurations';
import { ConfigEntryType } from 'config/config';

function useInsightsMenu({ insightsModule }: { insightsModule: ConfigEntryType | undefined }) {
  const { companyId } = useUserData();
  const { activeUniqueEntries, isLoading: isLoadingGroupByValues } = useConfigQuery({
    companyId,
    configName: insightsModule?.referenceObject?.groupBy?.configRefName,
    shouldFetch:
      insightsModule?.referenceObject?.groupBy?.isActive ||
      insightsModule?.referenceObject?.groupBy?.isActive === undefined,
  });
  // const {
  //   filters: { [companyId]: { insightType: insightTypeFromStore = '' } = {} },
  //   setFilters: setInsightsFiltersStore,
  // } = useInsightsFiltersStore();
  const sortByMenu = useMemo(
    () =>
      insightsModule?.referenceObject?.groupBy?.configRefName === undefined
        ? [
            { label: 'Specifications', value: InsightType.MasterFormat },
            { label: 'Building Systems', value: InsightType.UniFormat },
          ]
        : activeUniqueEntries.map((entry) => ({
            label: entry.referenceObject?.label || entry.entryDescription || entry.entryCode,
            value: entry.entryCode,
          })),
    [activeUniqueEntries],
  );
  const getDefaultMenuOption = useCallback(
    () => sortByMenu?.[0] || { label: '', value: '' },
    [sortByMenu],
  );
  const [menu, setMenu] = useState<SortMenuType>({
    selectedOption: getDefaultMenuOption(),
    options: sortByMenu,
  });

  useEffect(() => {
    setMenu((prevState) => ({
      ...prevState,
      options: sortByMenu,
      selectedOption: prevState.selectedOption.value
        ? prevState.selectedOption
        : getDefaultMenuOption(),
    }));
  }, [sortByMenu, getDefaultMenuOption]);

  useEffect(() => {
    if (menu.selectedOption.value) {
      // setInsightsFiltersStore({
      //   companyId,
      //   insightType: menu.selectedOption.value as InsightType,
      // });
    }
  }, [menu.selectedOption.value, companyId]);

  return {
    isLoadingGroupByValues,
    menu,
    setMenu,
  };
}

export default useInsightsMenu;
